import axios from "axios";

const config = {
  HEADER:{
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin':  `*`,
    'Access-Control-Allow-Methods': 'POST',
    'Access-Control-Allow-Headers': 'X-Requested-With,content-type'
  }
};

export const get = (url) => {
	return axios.get(url, config);
}